export default __webpack_public_path__ + "static/media/LoggingCampMap.59cd3153.jpg";